<template>
  <a v-bind:href="`https://www.google.com/search?q=艦これ+${quest.name}`" target="_blank" rel="noopener noreferrer">
    <div class="google-button">
      <img src="../../../static/assets/google.png" alt="google" title="google" class="google-icon">
    </div>
  </a>
</template>

<script>
export default {
  name: 'GoogleButton',
  props: ['quest']
}
</script>

<style scoped>
.google-button {
  cursor: pointer;
  margin: 3px;
  width: 32px;
  height: 32px;
}
.google-button a:visited {
  color: #000000;
}
.google-icon {
  width: 32px;
  height: 32px;
}
</style>



// WEBPACK FOOTER //
// src/components/quest_modal/GoogleButton.vue